import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClassroomMeetingFormWrapperModule } from '@app/classrooms/_components/meeting-form-wrapper/meeting-form-wrapper.module';
import { ClassroomCardModule } from '@app/classrooms/classroom-page/_components';
import { MobileModalModule } from '@app/core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@app/core/components/modal/modal.module';
import { CategoriesItemComponent } from '@app/library/panes/categories-content-filter/categories-item/categories-item.component';
import { ContentNotFoundModule } from '@app/shared';
import { BreadcrumbsModule } from '@core/components/breadcrumbs/breadcrumbs.module';
import { TranslateModule } from '@ngx-translate/core';
import { OnUiButtonModule, OnUiTabsModule } from 'onclass-ui';
import { InviteToClassroomModule } from '../_components/invite-to-classroom/invite-to-classroom.module';
import { ClassroomContentPageModule } from './classroom-content-page/classroom-content-page.module';
import { ClassroomMeetingsPageModule } from './classroom-meetings-page/classroom-meetings-page.module';
import { ClassroomPageRoutingModule } from './classroom-page-routing.module';
import { ClassroomPageComponent } from './classroom-page.component';
import { ClassroomParticipantsPageModule } from './classroom-participants-page/classroom-participants-page.module';

@NgModule({
  declarations: [ClassroomPageComponent],
  imports: [
    CommonModule,
    TranslateModule,

    ModalModule,
    MobileModalModule,

    InviteToClassroomModule,
    ClassroomMeetingFormWrapperModule,

    ClassroomCardModule,
    ClassroomMeetingsPageModule,
    ClassroomContentPageModule,
    ClassroomParticipantsPageModule,

    ClassroomPageRoutingModule,
    ContentNotFoundModule,
    BreadcrumbsModule,
    OnUiButtonModule,
    OnUiTabsModule,
    CategoriesItemComponent,
  ],
})
export class ClassroomPageModule {}
